module.exports = __webpack_public_path__ + "img/belgium-colorectal-cancer-male.7e50d8a9.png";